export const GAME_STATE_CHOOSING_CARDS = "GAME_STATE_CHOOSING_CARDS";
export const GAME_STATE_REVEALING_CARDS = "GAME_STATE_REVEALING_CARDS";
export const GAME_STATE_ALL_CARDS_CHOOSEN = "GAME_STATE_ALL_CARDS_CHOOSEN";
export const GAME_STATE_NEW_ROUND = "GAME_STATE_NEW_ROUND";
export const NEW_CARD_VALUE = "NEW_CARD_VALUE";
export const NEW_CARD_STYLE = "NEW_CARD_STYLE";
export const AI_COMMENT = "AI_COMMENT";
export const AI_FACT = "AI_FACT";
